<template>
  <HorizontalField label="Additional Discount Voucher" class="voucher has-long-label">
    <input
      name="voucher"
      v-model="voucher"
      type="text"
      class="input"
      :disabled="discountPercentage !== null" />
    <input
      type="hidden"
      name="voucher_code"
      :value="voucher"
      v-if="discountPercentage !== null" />
    <template v-slot:addons>
      <div class="control">
        <button
          :class="{ button: true, 'is-loading': loading }"
          :disabled="discountPercentage !== null"
          @click="applyVoucher">
          Apply
        </button>
      </div>
    </template>
    <p v-if="errorMessage" class="help is-danger">{{ errorMessage }}</p>
    <p v-if="discountPercentage !== null" class="help is-success">
      ✔ Discount: {{ discountPercentage }}%
    </p>
  </HorizontalField>
</template>

<script>
import axios from "axios";
import HorizontalField from "@/components/HorizontalField.vue";
export default {
  components: {
    HorizontalField,
  },
  data() {
    return {
      voucher: "",
      discountPercentage: null,
      errorMessage: "",
      loading: false,
    };
  },
  methods: {
    async applyVoucher(event) {
      event.preventDefault();
      try {
        this.loading = true;
        const response = await axios.post("/register/validate-voucher/", {
          code: this.voucher,
        });
        if (response.data.valid) {
          this.discountPercentage = response.data.discountPercentage;
          this.errorMessage = "";
          this.$emit("update:discountPercentage", this.discountPercentage);
        } else {
          this.discountPercentage = null;
          this.errorMessage = "Invalid voucher code.";
        }
      } catch (error) {
        this.discountPercentage = null;
        this.errorMessage = "An error occurred while validating the voucher code.";
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
<style></style>
